<template>
  <div class="footer" id="footer" :class="{ 'fixed': fixedflag }" v-show="footerflag">
    <div class="container">
      <div class="friendlink" v-if="linksArr && linksArr.length > 0">
        <a href="javascript:void(0)">友情链接：</a>
        <a v-for="(item, index) in linksArr" :key="index" :href="item.adLink" target="_blank">{{ item.name }}</a>
      </div>
      <div class="" v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      content: '',
      List: [],
      linksArr: [],
      bodyHeight: 0,
      bodyTimer: null,
      fixedflag: true,
      footerflag: true
    }
  },
  components: {
  },
  computed: {
    adSlot () {
      return this.$store.state.adSlot.list
    }
  },
  watch: {
    adSlot (val) {
      if (val) {
        this.List = val
        this.getData()
      }
    },
    bodyHeight (val) {
      // console.log(val)
      if (val) {
        if (val < document.documentElement.clientHeight) {
          this.fixedflag = true
        } else {
          this.fixedflag = false
        }
      }
    },
    '$route.path' (newval, oldval) {
      if (newval.indexOf('culturemap') > -1) {
        this.footerflag = false
      } else {
        this.footerflag = true
      }
    }
  },
  mounted () {
    if (this.$store.state.adSlot.list.length !== 0) {
      this.List = this.$store.state.adSlot.list
      this.getData()
    }
    this.$nextTick(() => {
      this.bodyTimer = setTimeout(() => {
        this.bodyHeight = document.body.clientHeight
        if (this.bodyHeight > 0) {
          clearTimeout(this.bodyTimer)
        }
      }, 100)
    })
  },
  methods: {
    getData () {
      this.List.forEach(item => {
        if (item.slotCode === 'footer') {
          if (item.slotDesc !== undefined && item.slotDesc !== '') {
            this.content = item.slotDesc
          } else {
            this.content = '无'
          }
        }
        if (item.slotCode === 'links') {
          item.adDetails.forEach(items => {
            let obj = {
              'name': items.adName,
              'adLink': items.adLink
            }
            this.linksArr.push(obj)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.footer{
  background: #333333;
  padding: 15px 0;
  text-align: center;
  /deep/ .container{
    div{
      color: rgba(255, 255, 255, 0.6) !important;
      a,
      p,
      span,
      strong{
        display: inline-block;
        margin: 0 5px;
      }
    }
  }
  &.fixed{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue